import { CSSProperties } from 'react';
import { LanguageSwitcherProps } from './LanguageSwitcher.types';

export const getButtonStyle = (
  props: Partial<LanguageSwitcherProps>,
): CSSProperties => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: props.backgroundColor || '#ffffff',
  color: '#1f2937',
  border: `1px solid ${props.borderColor || '#e5e7eb'}`,
  borderRadius: props.borderRadius || '8px',
  height: props.height || '38px',
  width: props.width || '70px',
  padding: '0',
  boxShadow: 'none',
});

export const dropdownMenuStyle: CSSProperties = {
  borderRadius: '8px',
  padding: '4px',
  minWidth: '160px',
  overflowX: 'hidden',
};
